import { IMealPlan } from "../../types/plan";

export class PlanDb {
    private dbName = 'PlanDB';
    private dbVersion = 2;
    private storeName = 'plans';

    async initDB(): Promise<void> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = () => {
                reject(request.error);
            };

            request.onsuccess = () => {
                resolve();
            };

            request.onupgradeneeded = (event) => {
                const db = (event.target as IDBOpenDBRequest).result;
                if (!db.objectStoreNames.contains(this.storeName)) {
                    const store = db.createObjectStore(this.storeName, { 
                        keyPath: 'id',
                        autoIncrement: true
                    });
                    // Add compound index for user+date+meal
                    store.createIndex('userDateMeal', ['user', 'date', 'meal'], { unique: true });
                }
            };
        });
    }

    async addPlans(plans: IMealPlan[], clear?: boolean): Promise<void> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        if (clear) {
            const clearRequest = store.clear();
            clearRequest.onsuccess = () => {
              console.log("cleared plans");
            };
          }

        return new Promise((resolve, reject) => {
            plans.forEach(plan => {
                store.put(plan);
            });

            transaction.oncomplete = () => {
                resolve();
            };

            transaction.onerror = () => {
                reject(transaction.error);
            };
        });
    }

    async getPlans(): Promise<IMealPlan[]> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            const request = store.getAll();

            request.onsuccess = () => {
                resolve(request.result);
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    async getPlan(filter: Partial<IMealPlan>): Promise<IMealPlan | null> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readonly');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            const request = store.openCursor();
            
            request.onsuccess = () => {
                const cursor = request.result;
                if (cursor) {
                    const plan = cursor.value as IMealPlan;
                    const matches = Object.entries(filter).every(
                        ([key, value]) => plan[key as keyof IMealPlan] === value
                    );
                    
                    if (matches) {
                        resolve(plan);
                        return;
                    }
                    cursor.continue();
                } else {
                    resolve(null);
                }
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    async updatePlan(plan: IMealPlan): Promise<void> {
        const db = await this.getDB();
        const transaction = db.transaction(this.storeName, 'readwrite');
        const store = transaction.objectStore(this.storeName);

        return new Promise((resolve, reject) => {
            // Put will update if exists, create if not
            const request = store.put(plan);
            
            request.onsuccess = () => {
                resolve();
            };

            request.onerror = () => {
                reject(request.error);
            };
        });
    }

    // async deletePlan(plan: IMealPlan): Promise<void> {
    //     const db = await this.getDB();
    //     const transaction = db.transaction(this.storeName, 'readwrite');
    //     const store = transaction.objectStore(this.storeName);

    //     return new Promise((resolve, reject) => {
    //         const request = store.delete();
            
    //         request.onsuccess = () => {
    //             resolve();
    //         };

    //         request.onerror = () => {
    //             reject(request.error);
    //         };
    //     });
    // }

    private async getDB(): Promise<IDBDatabase> {
        return new Promise((resolve, reject) => {
            const request = indexedDB.open(this.dbName, this.dbVersion);

            request.onerror = () => {
                reject(request.error);
            };

            request.onsuccess = () => {
                resolve(request.result);
            };
        });
    }
}